import { VF_SUB_SECTION_TITLE } from 'AppSrc/core/components/forms/form-base-components/v-f-sub-section-title';

const fieldId = 'reason-for-failure-and-resulting-impact';

const validator = () => null;

const vFParams = {
  fieldTitle: 'Reason for Failure and Resulting Impact',
};

const reasonForFailureAndResultingImpact = {
  id: fieldId,
  validator,
  vFParams,
  fieldType: VF_SUB_SECTION_TITLE,
};

export { reasonForFailureAndResultingImpact };
